import React, {Fragment} from 'react'

import CustomPropTypes from '../../customPropTypes'

import AlwaysHead from './AlwaysHead'

const PageMaster = ({children}) => (
  <Fragment>
    {/* Includes this component to set the og:url */}
    <AlwaysHead />
    {children}
  </Fragment>
)

PageMaster.propTypes = {children: CustomPropTypes.children}

export default PageMaster
